import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Museum from "./pages/Museum.js";
import Add from "./pages/Add.js";
import Update from "./pages/Update.js";
import Manage from "./pages/Manage.js";
import AddPlatform from "./pages/AddPlatform.js";
import UpdatePlatform from "./pages/UpdatePlatform.js";
import Game from "./pages/Game.js";
import GameDetails from "./pages/GameDetails.js";
import About from "./pages/Support.js";
import Terms from "./pages/Terms.js";
import ReconDB from "./pages/ReconDB.js";
import NotFound from "./pages/NotFound.js";
import Enlist from "./pages/Enlist.js";
import Feed from "./pages/Feed.js";
import Panorama from "./pages/Panorama.js";
import Login from "./pages/Login.js";
import Feedback from "./pages/Feedback.js";
import ManageFeedbackThread from "./pages/ManageFeedbackThread.js";
import GameSearch from "./pages/GameSearch.js";
import FengCheng from "./pages/FengCheng.js";
import Archives from "./pages/Archives.js";
import KamuLewu from "./pages/KamuLewu.js";
import NewspaperArchive from "./pages/NewspaperArchive.js";
import OralHistory from "./pages/OralHistory.js";
import SeoManager from "./components/Seo.js";
import GameContributionHub from "./pages/GameContributionHub.js";
import GameSubmissionThanks from "./pages/GameSubmissionThanks.js";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SeoManager />
        <Routes>
          <Route path="/" element={<Panorama />} />
          <Route path="/games" element={<Museum />} />
          <Route path="/games/platform/:platformId" element={<Museum />} />
          <Route path="/feed" element={<Feed />} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/manage-feedback-thread/:threadId" element={<ManageFeedbackThread />} />
          <Route path="/login" element={<Login />} />
          <Route path="/add" element={<Add />} />
          <Route path="/submit-game" element={<Add visitorMode />} />
          <Route path="/contribute-games" element={<GameContributionHub />} />
          <Route path="/contribute-games/requests" element={<GameContributionHub />} />
          <Route path="/contribute-games/recent" element={<GameContributionHub />} />
          <Route path="/contribute-games/submitted/:id" element={<GameSubmissionThanks />} />
          <Route path="/update/:id" element={<Update />} />
          <Route path="/manage" element={<Manage />} />
          <Route path="/manage/pending-game/:id" element={<GameDetails previewMode />} />
          <Route path="/manage/pending-game/:id/play" element={<Game previewMode />} />
          <Route path="/addplatform" element={<AddPlatform />} />
          <Route path="/updateplatform/:id" element={<UpdatePlatform />} />
          <Route path="/game/:id" element={<Game />} />

          <Route path="/game-details/:id" element={<GameDetails />} />
          <Route path="/about" element={<About />} />
          <Route path="/about/terms" element={<Terms />} />
          <Route path="/recondb" element={<ReconDB />} />
          <Route path="/enlist" element={<Enlist />} />
          <Route path="/search" element={<GameSearch />} />
          <Route path="/search/track/:trackId" element={<GameSearch />} />
          <Route path="/search/recent" element={<GameSearch />} />
          <Route path="/fc" element={<FengCheng />} />
          <Route path="/archives" element={<Archives />} />
          <Route path="/kamulewu" element={<KamuLewu />} />
          <Route path="/newspaper-archive" element={<NewspaperArchive />} />
          <Route path="/newspaper-archive/article/:articleId" element={<NewspaperArchive />} />
          <Route path="/oral-history" element={<OralHistory />} />
          <Route path="/oral-history/:slug" element={<OralHistory />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
